import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Typography, useMediaQuery, IconButton, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import { LearnersProfile } from "../../../../helper/base_url";
import { isTokenExpired } from "../../../../utils/tokenUtils";
import { jwtDecode } from "jwt-decode";

const DashboardHeader = () => {
  const [data, setData] = useState({
    name: "",
    username: "",
    profilePic: "",
  });

  const isMobile = useMediaQuery("(max-width :600px)");
  const isTablet = useMediaQuery("(max-width :900px)");

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "https://site.huebits.in/learners";
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || isTokenExpired(token)) {
      logout();
      return;
    }

    let timer;
    try {
      const decoded = jwtDecode(token);
      const expiryTime = decoded.exp * 1000;
      const currentTime = Date.now();
      const timeout = expiryTime - currentTime;

      timer = setTimeout(() => {
        logout(); // Auto logout when token expires
      }, timeout);
    } catch (err) {
      console.error("Token decode error:", err);
      logout();
      return;
    }

    const fetchProfilePic = async () => {
      try {
        const res = await axios.get(`${LearnersProfile}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        });

        const profile = res.data?.data;
        if (profile) {
          setData({
            name: profile.name || "",
            username: profile.username || "",
            profilePic: profile.profileImageUrl || "",
          });
        }
      } catch (err) {
        console.error("Error fetching profile data:", err);
      }
    };

    fetchProfilePic();

    // Clear logout timer on unmount
    return () => clearTimeout(timer);
  }, []);

  return (
   <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        px: isMobile ? 2 : 4,
        padding:"10px 40px",
        backgroundColor: "#ffffff",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
        position: "sticky",
        top : 0,
        zIndex: 1000,
        width : "100%",
      }}
    >
      {/* Welcome Message */}
      <Box sx={{ flex: 1 }}>
        <Typography
          variant={isMobile ? "h6" : "h5"}
          sx={{
            fontWeight: 700,
            color: "rgba(0, 0, 0, 1)",
            fontSize: isMobile ? "16px" : isTablet ? "18px" : "20px",
            lineHeight : 1.4,
            marginLeft : isMobile ? "20px" : isTablet ? "20px" : "0px",
          }}
        >
          Welcome back, {" "}
          <Box component="span" sx={{ color: "rgb(27, 110, 244)", fontWeight: 800 }}>
            {data?.name || data?.username}
          </Box>{" "}
        </Typography>
      </Box>

      {/* Profile Picture + Logout */}
      <Box sx={{ display: "flex", justifyContent:"flex-end", alignItems: "center", gap: 2 }}>
        <Link
          to="/learners/embedded-systems-dashboard/userprofile"
          style={{ textDecoration: "none" }}
        >
          <Box
            sx={{
              width : 42,
              height : 42,
              borderRadius: "50%",
              overflow: "hidden",
              backgroundColor: "#f0f0f0",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #dbe9ff",
              transition: "0.3s",
              "&:hover": {
                borderColor: "rgb(27, 110, 244)",
              },
            }}
          >
            {data.profilePic ? (
              <img
                src={data.profilePic}
                alt="Profile"
                style={{
                  width : "100%",
                  height : "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <PersonOutlinedIcon
                sx={{ color: "rgb(27, 110, 244)", fontSize: 26 }}
              />
            )}
          </Box>
        </Link>

        <Tooltip title="Logout">
          <IconButton
            onClick={logout}
            sx={{
              color: "rgb(27, 110, 244)",
              "&:hover": { backgroundColor: "#f2f8ff" },
            }}
          >
            <LogoutIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default DashboardHeader;
